import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import OnboardingFirstActivityModal from 'app/domains/routes/OnBoarding/OnBoardingFirstActivityModal/OnBoardingFirstActivityModal'
import {
  getActivityImage,
  getActivityDescription,
  getActivityProQuote,
  getActivityProQuoteAuthor,
  getActivityId,
  getActivityUserActivityId,
  getActionType,
} from 'store/entities/activity/selectors'
import { activityActions, setFirstLogin } from 'store/entities/identity/actions'
import { isPreTrackSurveyEnabled } from 'store/entities/identity/selectors'
import { modal } from 'store/entities/modal/actions'
import OnboardingBriefQuiz from 'app/domains/routes/OnBoarding/OnBoardingBriefQuiz'

const mapStateToProps = createStructuredSelector({
  image: getActivityImage,
  description: getActivityDescription,
  proQuote: getActivityProQuote,
  proQuoteAuthor: getActivityProQuoteAuthor,
  activityId: getActivityId,
  userActivityId: getActivityUserActivityId,
  isPreTrackSurveyEnabled,
  currentActionCommitType: getActionType,
})

const mergeProps = (
  { isPreTrackSurveyEnabled, ...restState }: { isPreTrackSurveyEnabled: boolean },
  { dispatch }: any,
  ownProps: any
) => {
  return {
    ...restState,
    ...ownProps,
    onDid: ({ activityId, userActivityId }: { activityId: number; userActivityId: number }) => {
      dispatch(activityActions.did({ activityId, userActivityId }))
    },
    closeModalOrShowQuiz: () => {
      dispatch(setFirstLogin(false))
      if (isPreTrackSurveyEnabled) {
        dispatch(modal.show(OnboardingBriefQuiz, { size: 'md', important: true }))
      } else {
        dispatch(modal.hide())
      }
    },
  }
}

export default connect(mapStateToProps, null, mergeProps)(withTranslation('user')(OnboardingFirstActivityModal) as any)
